import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { AppSettings } from 'src/app/shared/app-settings';
import { User } from '../models/current-user';
import { ConfigService } from './config.service';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  public currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  public isUserInLoggedIN = new EventEmitter();
  public isHeaderShow:Observable<any>;
  data = new EventEmitter();
  private adminUsers = [];

  constructor(private http: HttpClient,private configService: ConfigService) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
    this.isHeaderShow = this.isUserInLoggedIN.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  public setHeadingEnabled(obj: any) {
    this.isHeaderShow = obj;
    this.isUserInLoggedIN.emit(obj);
  }

  public getHeadingEnabled() {
    return this.isHeaderShow;
  }

  public setcurrentUserValue(user) {
    localStorage.setItem('currentUser', JSON.stringify(user));
    this.currentUserSubject.next(user);
    return user;
  }

  hasPrivilege(privilege) {
    const user = this.currentUserSubject.value;
    return (
      user?.role?.indexOf('ADMIN') >= 0 ||
      user?.privileges?.indexOf(privilege) >= 0 ||
      this.configService.isFeatureEnabled('userMgmt')
    );
  }

  hasAdminPrivilege(): boolean {
    const roles = this.currentUserSubject.value?.role;
    const hasAdmin = Array.isArray(roles)
      ? roles.map(r => r.toLowerCase()).includes('admin')
      : roles?.toLowerCase() === 'admin';
    return hasAdmin || this.configService.isFeatureEnabled('userMgmt');
  }

  hasEditUserPrivilege(): boolean {
    const roles = this.currentUserSubject.value?.role;
    const hasEditRole = Array.isArray(roles)
      ? roles.map(r => r.toLowerCase()).includes('edit user access menu')
      : roles?.toLowerCase() === 'edit user access menu';
      // console.log(hasEditRole)
    return hasEditRole || this.configService.isFeatureEnabled('userMgmt');
  }
  
  hasViewUserPrivilege(): boolean {
    const roles = this.currentUserSubject.value?.role;
    const hasViewRole = Array.isArray(roles)
      ? roles.map(r => r.toLowerCase()).includes('view user access menu')
      : roles?.toLowerCase() === 'view user access menu';
    return hasViewRole || this.configService.isFeatureEnabled('userMgmt');
  }
  
  externalLoginPostRequestOld(url, obj) {
    return new Promise<any>((resolve, reject) => {
      this.http.post(`${AppSettings.API_ENDPOINT}/${url}`, obj).
        subscribe((res: any) => {
          if (res) {
            let response = res;
            let currUser = {
              "id": response.user.id,
              "email": response.user.email,
              "firstName": response.user.firstName,
              "lastName": response.user.lastName,
              "access_token": response.token,
              "role": response.user.roles,
              "picture": response.user.picture,
              "privileges": response.user.privileges
            };
            localStorage.setItem('currentUser', JSON.stringify(currUser));
            let user = localStorage.getItem('currentUser');
            this.currentUserSubject.next(JSON.parse(user));
          }
          resolve(res);
        },
          (err) => {
            reject(err);
          });
    });
  }

  externalLoginPostRequest(url, obj) {
    return this.http.post(`${AppSettings.API_ENDPOINT}/${url}`, obj);
  }

externalPortalLoginPostRequest(portalToken: string): Observable<any> {
   const url = `${AppSettings.API_ENDPOINT}/${AppSettings.PVADMINSSOLOGIN}?portalToken=${encodeURIComponent(portalToken)}`;
  return this.http.post(url, null)
    .pipe(
      catchError(err => {
        console.error('SSO login POST failed', err, JSON.stringify(err));
        return throwError(() => err);
      })
    );
}

  logout() {
    localStorage.removeItem('currentUser');
    localStorage.clear();
    this.currentUserSubject.next(null);
    localStorage.removeItem('deviceDrpdwnObj');
    localStorage.removeItem('pmData');
  }

  roleMatch(allowedRoles): boolean {
    let isMatch = false;
    let user = this.currentUserSubject.value;
    let userRoles: any = user.role;

    allowedRoles.forEach(allowedRole => {
      userRoles.forEach(userRole => {
        if (allowedRole === userRole) {
          isMatch = true;
          return false;
        }
      });
    });
    return isMatch;
  }

  privilegeMatch(allowedPrivileges): boolean {
    let hasPrivilege = false;
    let user = this.currentUserSubject.value;
    let userPrivileges: string[] = user.privileges;
  
    allowedPrivileges.forEach(allowedPrivileges => {
      if (userPrivileges.includes(allowedPrivileges)) {
        hasPrivilege = true;
        return false;
      }
    });
  
    return hasPrivilege;
  }

  setimage(val){
    this.data.next(val);
  }

  getImage(){
    return this.data;
  }
}
